import React from "react";


function Contact() {
  return (
    <div>
      <div className="row banner" style={{backgroundImage:'url(./images/contact-Us.png)',backgroundSize:'cover',backgroundPosition:'center'}}></div>
      <div className="container" style={{marginTop:'100px',marginBottom:'100px'}}>
       
        <div className="row">
            <div className="col-md-5" style={{background:'#ffffffff',padding:'50px'}}>
               <div className="row" style={{borderBottom:'0px solid orange',paddingBottom:'15px',paddingTop:'15px'}}>
                    <h3 className="cheading" >Address</h3>
                    {/* first */}
                    <div class="row" style={{borderBottom:'1px solid orange',paddingBottom:'15px',marginBottom:'15px',width:'100%'}}>
                        <div className="col-md-1 middle">
                          <i class="fa fa-map-marker contacticons" aria-hidden="true"></i>
                        </div>
                        <div className="col-md-10 ">
                            <p className="addr">The Executive Officer <br />
                              Ulsavamadam Building , North Nada
                              Sree Padmanabha Swamy Temple Fort,<br />
                              Thiruvananthapuram – 695023.</p>                                               
                        </div>
                    </div>
                    <div class="row" style={{borderBottom:'1px solid orange',paddingBottom:'15px',marginBottom:'15px',width:'100%'}}>
                        <div className="col-md-1 middle">
                          <i class="fa fa-phone-square contacticons" aria-hidden="true"></i>
                        </div>
                        <div className="col-md-10 ">
                            <p className="addr">0471-2450233</p>                                               
                        </div>
                    </div>
                    <div class="row" style={{borderBottom:'1px solid orange',paddingBottom:'15px',marginBottom:'15px',width:'100%'}}>
                        <div className="col-md-1 middle">
                          <i class="fa fa-envelope contacticons" aria-hidden="true"></i>
                        </div>
                        <div className="col-md-10 ">
                            <p className="addr">mathilakamofficespst@gmail.com <br />
                              catoeospst@gmail.com
                            </p>                                               
                        </div>
                    </div>
                    
                </div>
           </div> 
           <div className="col-md-7" style={{backgroundSize:'cover',backgroundPosition:'center'}}>
             <iframe
        title="Google Map"
        src="https://www.google.com/maps/embed?pb=!1m28!1m12!1m3!1d25766.17342509899!2d76.93976575387063!3d8.476575175348014!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m13!3e6!4m5!1s0x3b05bb09b7e81d35%3A0x1d2fedb7213a1ef7!2sSree%20Padmanabhaswamy%20Temple%2C%20Sree%20Padmanabha%20Swamy%20Temple%2C%20West%20Nada%2C%20Fort%2C%20East%20Fort%2C%20Pazhavangadi%2C%20Thiruvananthapuram%2C%20Kerala!3m2!1d8.4827779!2d76.9435906!4m5!1s0x3b05bb09b7e81d35%3A0x1d2fedb7213a1ef7!2sWest%20Nada%2C%20Fort%2C%20East%20Fort%2C%20Pazhavangadi%2C%20Thiruvananthapuram%2C%20Kerala%20695023!3m2!1d8.4827779!2d76.9435906!5e0!3m2!1sen!2sin!4v1757915200134!5m2!1sen!2sin"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
      ></iframe>

       

           </div>           
        </div>
        
        
      </div>
    </div>
  );
}

export default Contact;